import { createContext, useContext } from 'react';

const PurchaseContext = createContext();

PurchaseContext.displayName = 'PurchaseContext';

const usePurchase = () => useContext(PurchaseContext);

export { PurchaseContext, usePurchase };
